export default "__VITE_ASSET__Chyp3PO6__"